/* eslint-disable prettier/prettier */
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from '../locales/en.json'
import es from '../locales/es.json'

const bmiCalculatorI18n = i18n.createInstance()

bmiCalculatorI18n
  .use(LanguageDetector)
  .init({
    order: ['htmlTag', 'path', 'subdomain'],
    resources: {
      en,
      es,
    },
    debug: false,
    detection: {
      order: [ 'htmlTag', 'path']
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export default bmiCalculatorI18n
